import { SubjetivoInput } from 'graphql/types.generated'

import { SubjetivoFormModel } from './SubjetivoForm'

export const convertSubjetivoFormToInput = (form: SubjetivoFormModel): SubjetivoInput =>
  form && {
    texto: form.texto,
    motivos: form.motivos?.map((motivo) => ({ ciap: motivo.ciap.id, observacao: motivo.observacao })),
  }
